export default __webpack_public_path__ + "static/media/aviaInfo.b450f4ab.png";